import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useMemo, createElement as _createElement } from 'react';
import { FieldDecorator } from '@snack-uikit/fields';
import { ToggleGroup } from '@snack-uikit/toggles';
import { parseKeyToDataTest } from '../../../utils';
import { SegmentedControlCard } from './SegmentedControlCard';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function SegmentedControlUi(_ref) {
  var _ref2, _relatedUiProps$visib;
  var decoratorProps = _ref.decoratorProps,
    uiProps = _ref.uiProps,
    value = _ref.value,
    onChange = _ref.onChange,
    itemsProp = _ref.items,
    relateFn = _ref.relateFn,
    watchedValues = _ref.watchedValues,
    accessorKey = _ref.accessorKey;
  var _useMemo = useMemo(function () {
      var _relateFn;
      return (_relateFn = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn !== void 0 ? _relateFn : {};
    }, [relateFn, watchedValues]),
    relatedItems = _useMemo.items,
    relatedDecoratorProps = _useMemo.decoratorProps,
    relatedUiProps = _useMemo.uiProps;
  var items = useMemo(function () {
    return relatedItems !== null && relatedItems !== void 0 ? relatedItems : itemsProp;
  }, [itemsProp, relatedItems]);
  var dataTestAttribute = parseKeyToDataTest('segmented', accessorKey);
  useEffect(function () {
    if (!items.find(function (item) {
      return String(item === null || item === void 0 ? void 0 : item.value) === String(value);
    })) {
      var _items$;
      onChange === null || onChange === void 0 ? void 0 : onChange(String(items === null || items === void 0 ? void 0 : (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.value));
    }
  }, [value, onChange, items, relatedItems]);
  var visible = (_ref2 = (_relatedUiProps$visib = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.visible) !== null && _relatedUiProps$visib !== void 0 ? _relatedUiProps$visib : uiProps === null || uiProps === void 0 ? void 0 : uiProps.visible) !== null && _ref2 !== void 0 ? _ref2 : true;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsx(FieldDecorator, _objectSpread(_objectSpread(_objectSpread({}, decoratorProps), relatedDecoratorProps), {}, {
    size: "m",
    "data-test-id": dataTestAttribute,
    children: /*#__PURE__*/_jsx(ToggleGroup, {
      selectionMode: "single",
      value: value,
      onChange: function (_onChange) {
        function onChange(_x) {
          return _onChange.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange.toString();
        };
        return onChange;
      }(function (value) {
        value && (onChange === null || onChange === void 0 ? void 0 : onChange(value));
      }),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.container,
        children: items.map(function (item) {
          var _relatedUiProps$disab;
          return /*#__PURE__*/_createElement(SegmentedControlCard, _objectSpread(_objectSpread({
            disabled: (_relatedUiProps$disab = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.disabled) !== null && _relatedUiProps$disab !== void 0 ? _relatedUiProps$disab : uiProps === null || uiProps === void 0 ? void 0 : uiProps.disabled
          }, item), {}, {
            key: item === null || item === void 0 ? void 0 : item.value
          }));
        })
      })
    })
  }));
}